// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Services
import MonitoringAlert from 'services/data/monitoring-alert';

// Components
import TriageItem from './triage-item';
import { alerts } from 'modules/alerts/actions';
import { MonitoringAlertDetails, Claim, Resolve } from './triage-options';


export default class MonitoringAlertItem extends React.Component {
  static propTypes = {
    item: PropTypes.shape({
      open: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
      ]),
      setOpen: PropTypes.func
    }),
    currentUser: PropTypes.object.isRequired,
    eagerUpdate: PropTypes.func.isRequired,
    onDashboard: PropTypes.bool
  };

  constructor() {
    super();

    this.update = this.update.bind(this);
    this.claim = this.claim.bind(this);
  }

  update(item) {
    this.props.eagerUpdate(item, 'monitoringalert');

    return MonitoringAlert.update(item);
  }

  claim(item) {
    const user = this.props.currentUser;
    const update = _.defaults({ claimedBy: user, status: 'Active' }, item);

    this.props.eagerUpdate(update, 'monitoringalert');

    return MonitoringAlert.claim(item.id)
      .catch(error => {
        if (!error.response || error.response.status !== 404) return;

        alerts.warning({ title: 'Monitoring alert has already been claimed' });
      });
  }

  render() {
    const { item: monitoringAlert, currentUser, onDashboard, ...passed } = this.props;
    const { open } = MonitoringAlert;
    const claimed = !_.isEmpty(monitoringAlert.claimedBy);
    const ok = monitoringAlert.monitoringAlertStatus === 'Ok';
    const needsResolution = _.includes(['Active', 'After Hours'], monitoringAlert.status) && ok;
    const url = `https://monitor.praece.com/history.php?itemids[0]=${monitoringAlert.itemId}&action=showlatest`;
    let prefix = '';
    
    if (monitoringAlert.autoResolved) prefix = '(AR) ';
    if (ok && !monitoringAlert.autoResolved) prefix = '(OK) ';
    
    const text = prefix + monitoringAlert.trigger;
    const payload = onDashboard ? text : <a href={url} target="_blank">{text}</a>;

    return (
      <TriageItem
        {...passed}
        itemOrigin={monitoringAlert.hostname}
        payloadOrStatus={payload}
        currentUser={currentUser}
        onDashboard={onDashboard}
        updateTriageItem={this.update}
        triageItem={monitoringAlert}
      >
        <MonitoringAlertDetails monitoringAlert={monitoringAlert} />

        { !open && (!claimed || needsResolution) &&
          <div className="triage-primary-options">
            { !claimed && <Claim triageItem={monitoringAlert} claim={this.claim} /> }
            { needsResolution && <Resolve triageItem={monitoringAlert} updateTriageItem={this.update} /> }
          </div>
        }
      </TriageItem>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/monitoring-alert.js